import { Add as AddIcon } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid";
import React from "react";

interface LedgerClassificationToolbarProps {
  onInsertRow: () => void;
}

function LedgerClassificationToolbar(props: LedgerClassificationToolbarProps) {
  return (
    <GridToolbarContainer sx={{ justifyContent: "flex-end" }}>
      <Box>
        <Button
          color="primary"
          startIcon={<AddIcon />}
          onClick={props.onInsertRow}
        >
          Inserir Classificação
        </Button>
      </Box>
    </GridToolbarContainer>
  );
}

export default LedgerClassificationToolbar;
